import {
  ONEY_PSP_ID,
  PLEDG_PSP_ID,
  UPLIFT_PSP_ID,
} from 'Components/widgets/payment-info/PaymentInfo.const';
import { UpliftForm } from './uplift-form/UpliftForm';
import { UpliftSelector } from './uplift-form/UpliftSelector';
import { UpliftFromPricing } from './uplift-form/UplfitFromPricing';
import { PledgForm } from './pledg-form/PledgForm';
import { PledgFromPricing } from './pledg-form/PledgFromPricing';
import { PledgPrice } from './pledg-form/PledgPrice';
import { OneySelector } from './oney-form/OneySelector';
import { OneyFromPricing } from './oney-form/OneyFromPricing';
import { DefaultBuyNowPayLaterIframe } from './DefaultBuyNowPayLaterIframe';

export const PAYMENT_PLAN_IFRAME = {
  [UPLIFT_PSP_ID]: UpliftForm,
  [PLEDG_PSP_ID]: PledgForm,
  [ONEY_PSP_ID]: DefaultBuyNowPayLaterIframe,
};

export const PAYMENT_PLAN_SELECTOR = {
  [UPLIFT_PSP_ID]: UpliftSelector,
  [PLEDG_PSP_ID]: PledgPrice,
  [ONEY_PSP_ID]: OneySelector,
};

export const BUY_NOW_PAY_LATER_PRICING = {
  [UPLIFT_PSP_ID]: UpliftFromPricing,
  [PLEDG_PSP_ID]: PledgFromPricing,
  [ONEY_PSP_ID]: OneyFromPricing,
};

export const BUY_NOW_PAY_LATER_PROVIDER = [UPLIFT_PSP_ID, PLEDG_PSP_ID, ONEY_PSP_ID];
